import { ChangeDetectionStrategy, Component, VERSION } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ThemeSwitcherComponent } from './theme-switcher/theme-switcher.component';
import { TenantSwitcherComponent } from './tenant-switcher/tenant-switcher.component';
@Component({
  selector: 'app-toolbar-dev',
  imports: [NgTemplateOutlet, RouterLink, MatButtonModule, MatIconModule, MatMenuModule, ThemeSwitcherComponent, TenantSwitcherComponent],
  templateUrl: './toolbar-dev.html',
  styleUrl: './toolbar-dev.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarDevComponent {
  readonly angularVersion = VERSION.full;
}
